import React, { useState } from "react";
import "./DirectListening.css";
import { part1Data } from "../../../data/directListening/part1Data";
import { part2Data } from "../../../data/directListening/part2Data";

const DirectListening = ({ isActive }) => {
  const [selectedPart, setSelectedPart] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [showEnglish, setShowEnglish] = useState(false);
  const [audioPlayed, setAudioPlayed] = useState(false);
  const [chunkStates, setChunkStates] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  const parts = [
    { id: "part1", title: "Part 1 - 사진 묘사" },
    { id: "part2", title: "Part 2 - 질문" },
  ];

  const getPartData = (partId) => {
    switch (partId) {
      case "part1":
        return part1Data;
      case "part2":
        return part2Data;
      default:
        return [];
    }
  };

  const handlePartSelect = (partId) => {
    const partData = getPartData(partId);
    setSelectedPart(partId);
    setCurrentQuestion(partData[0]);
    setShowEnglish(false);
    setAudioPlayed(false);
    setChunkStates(new Array(partData[0].chunks.length).fill(false));
    setCurrentQuestionIndex(0);
  };

  const playChunkAudio = (text) => {
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.rate = 0.9; // 속도 (0.1 ~ 10)
    utterance.pitch = 1; // 피치 (0 ~ 2)
    utterance.volume = 1; // 볼륨 (0 ~ 1)

    // 여성 목소리 선택 (가능한 경우)
    const voices = window.speechSynthesis.getVoices();
    const femaleVoice = voices.find(
      (voice) => voice.lang.includes("en") && voice.name.includes("female")
    );
    if (femaleVoice) utterance.voice = femaleVoice;

    window.speechSynthesis.speak(utterance);
  };

  const handleChunkClick = (index) => {
    // 영어 텍스트 음성 재생
    playChunkAudio(currentQuestion.chunks[index].english);

    // 해당 청크 영어로 변경
    const newChunkStates = [...chunkStates];
    newChunkStates[index] = true;
    setChunkStates(newChunkStates);
  };

  const playFullAudio = () => {
    if (selectedPart === "part2") {
      const questionNumber = currentQuestion.id.split("_")[1];
      const audioPath = `/audios/part2/direct/part2_${questionNumber}.mp3`;
      console.log("오디오 파일 경로:", audioPath);
      const audio = new Audio(audioPath);

      audio.onerror = (e) => {
        console.error("오디오 로드 실패:", e);
      };

      audio.onloadeddata = () => {
        console.log("오디오 로드 성공");
      };

      audio.play().catch((error) => {
        console.error("재생 실패:", error);
      });
    } else {
      playChunkAudio(currentQuestion.english);
    }
  };

  const handleNextQuestion = () => {
    const partData = getPartData(selectedPart);
    if (currentQuestionIndex < partData.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      setCurrentQuestion(partData[currentQuestionIndex + 1]);
      setChunkStates(
        new Array(partData[currentQuestionIndex + 1].chunks.length).fill(false)
      );
    }
  };

  const handlePrevQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
      setCurrentQuestion(getPartData(selectedPart)[currentQuestionIndex - 1]);
      setChunkStates(
        new Array(
          getPartData(selectedPart)[currentQuestionIndex - 1].chunks.length
        ).fill(false)
      );
    }
  };

  const renderPartSelection = () => (
    <div className="category-grid">
      {parts.map((part) => (
        <div
          key={part.id}
          className="category-card"
          onClick={() => handlePartSelect(part.id)}
        >
          <h3>{part.title}</h3>
        </div>
      ))}
    </div>
  );

  const renderQuestion = () => (
    <div className="question-container">
      <div className="audio-section">
        <button className="play-button" onClick={playFullAudio}>
          🔊 전체 듣기
        </button>
      </div>

      <div className="chunks-container">
        {currentQuestion.chunks.map((chunk, index) => (
          <div
            key={index}
            className={`chunk ${chunkStates[index] ? "active" : ""}`}
            onClick={() => handleChunkClick(index)}
          >
            <div className="chunk-korean">{chunk.korean}</div>
            {chunkStates[index] && (
              <div className="chunk-english">{chunk.english}</div>
            )}
          </div>
        ))}
      </div>

      {chunkStates.every((state) => state) && (
        <div className="english-text">{currentQuestion.english}</div>
      )}

      <div className="navigation-buttons">
        <button
          className="nav-button"
          onClick={handlePrevQuestion}
          disabled={currentQuestionIndex === 0}
        >
          ← 이전
        </button>
        <span className="question-counter">
          {currentQuestionIndex + 1} / {getPartData(selectedPart).length}
        </span>
        <button
          className="nav-button"
          onClick={handleNextQuestion}
          disabled={
            currentQuestionIndex === getPartData(selectedPart).length - 1
          }
        >
          다음 →
        </button>
      </div>
    </div>
  );

  return (
    <div className="direct-listening-container">
      <div className="direct-listening-header">
        <h2>LC 직청직해</h2>
        {selectedPart && (
          <button className="back-button" onClick={() => setSelectedPart(null)}>
            뒤로가기
          </button>
        )}
      </div>
      <div className="direct-listening-content">
        {selectedPart ? renderQuestion() : renderPartSelection()}
      </div>
    </div>
  );
};

export default DirectListening;
